import React, { SyntheticEvent, useCallback, useEffect } from 'react';
import t from 'modules/i18n/intl';

import { Radio } from '@atlaskit/radio';
import { BindProps } from 'modules/form';
import Help from 'components/common/Help';

type TaxIdRadioProps = {
  vatResponsible: boolean | null;
  vatStatus?: 'CORPORATE' | 'INDIVIDUAL' | null;
  isTaxIdFieldEmpty: boolean;
  VATRequiredMessageId: string;
  VATNotRequiredMessageId: string;
  isUkraine?: boolean;
};

const TaxIdRadio = ({
  field,
  vatResponsible,
  vatStatus,
  isTaxIdFieldEmpty,
  VATRequiredMessageId,
  VATNotRequiredMessageId,
  isUkraine,
}: BindProps<TaxIdRadioProps>) => {
  useEffect(() => {
    if (!!field && !isTaxIdFieldEmpty) {
      if (isUkraine) {
        field.edit(vatStatus ?? null);
      } else if (vatResponsible || vatResponsible === false) {
        field.edit(vatResponsible);
      } else {
        field.edit(null);
      }
    } else {
      field.edit(null);
    }
  }, [isTaxIdFieldEmpty, isUkraine, vatStatus]);

  const radioChangeHandle = useCallback(
    (e: SyntheticEvent<HTMLInputElement>) => {
      if (isUkraine) {
        if (e.currentTarget.value === 'required') {
          field.edit('CORPORATE');
        } else if (e.currentTarget.value === 'notRequired') {
          field.edit('INDIVIDUAL');
        }
      } else {
        if (e.currentTarget.value === 'required') {
          field.edit(true);
        } else if (e.currentTarget.value === 'notRequired') {
          field.edit(false);
        }
      }
    },
    [isUkraine],
  );

  if (!field || isTaxIdFieldEmpty) return null;

  const isRequiredChecked = isUkraine ? vatStatus === 'CORPORATE' : vatResponsible === true;
  const isNotRequiredChecked = isUkraine ? vatStatus === 'INDIVIDUAL' : vatResponsible === false;

  return (
    <>
      <Radio
        isChecked={isRequiredChecked}
        name="vatRequired"
        value="required"
        label={
          <>
            {t(VATRequiredMessageId)}
            {!isUkraine && <Help>{t('checkout.contact.tax-id-vat-required.help') as string}</Help>}
          </>
        }
        onChange={radioChangeHandle}
      />
      <Radio
        isChecked={isNotRequiredChecked}
        name="vatNotRequired"
        value="notRequired"
        label={t(VATNotRequiredMessageId)}
        onChange={radioChangeHandle}
      />
    </>
  );
};

export default TaxIdRadio;
